import React from 'react';
import SignupContainer from 'views/SignupContainer';
import VerifyEmailForm from 'shared/components/Forms/VerifyEmailForm';
import { useLocation } from 'react-router-dom';

const VerifyEmail: React.FC = () => {
  const location = useLocation();
  return (
    <SignupContainer>
      <VerifyEmailForm email={location.state} />
    </SignupContainer>
  );
};

export default VerifyEmail;
